import { closestCenter, DndContext, PointerSensor, useSensor, useSensors, } from '@dnd-kit/core';
import { arrayMove, SortableContext, verticalListSortingStrategy, } from '@dnd-kit/sortable';
import React, { useMemo } from 'react';
import ColumnCard from 'src/components/10-atoms/Card/ColumnCard';
import GenericServerError from 'src/components/10-atoms/GenericServerError';
import QueryHandler from 'src/components/10-atoms/QueryHandler';
import Label from 'src/components/10-atoms/form/Label';
import Column from 'src/components/10-atoms/layout/Column';
import ListLoaderLayout from 'src/components/10-atoms/loaders/ListLoaderLayout';
import { PRESSABLE_SIZE } from 'src/components/templates/PressableArea';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import useI18n from 'src/modules/translations/hooks/useI18n';
import SubjectItem from './Item';
import NoSubjects from './NoSubjects';
const SubjectListAPIHandler = ({ hasSubjects, queryState, onRetry, isEditMode = false, onEditSubject, onRearrangeSubjects, ...columnCardProps }) => {
    const [{ theme }] = useTheme(stylesGenerator);
    const { translate } = useI18n();
    const subjects = queryState.data?.ep_subjectList.list ?? [];
    const fallbackSubject = subjects[0];
    const subjectIDs = useMemo(() => subjects.map(subject => subject.id), [subjects]);
    const sensors = useSensors(useSensor(PointerSensor, {
        activationConstraint: { distance: 5 },
    }));
    const handleDragEnd = (event) => {
        const { active, over } = event;
        if (!over || active.id === over.id || !onRearrangeSubjects) {
            return;
        }
        const oldIndex = subjects.findIndex(subject => subject.id === active.id);
        const newIndex = subjects.findIndex(subject => subject.id === over.id);
        if (oldIndex < 0 || newIndex < 0) {
            return;
        }
        const reordered = arrayMove(subjects, oldIndex, newIndex);
        onRearrangeSubjects(reordered.map(subject => subject.id));
    };
    const renderSubjectList = () => (React.createElement(Column, { spacing: theme.spacing.standard.xxs }, subjects.map(subject => (React.createElement(SubjectItem, { key: subject.id, subject: subject, isEditMode: isEditMode, onEdit: onEditSubject, ...(isEditMode
            ? {}
            : {
                to: {
                    screen: 'EP_Subject',
                    params: { subjectID: subject.id },
                },
            }) })))));
    return (React.createElement(QueryHandler, { queryState: queryState, LoaderComponent: React.createElement(ColumnCard, { spacing: theme.spacing.standard.sm, ...columnCardProps },
            React.createElement(Label, null, translate('Subjects')),
            React.createElement(ListLoaderLayout, { ph: 0, loaderItemHeight: PRESSABLE_SIZE, count: 3 })), ErrorComponent: React.createElement(GenericServerError, { error: queryState.error, onRetry: onRetry }), DataComponent: () => !hasSubjects && fallbackSubject && !isEditMode ? (React.createElement(NoSubjects, { subject: fallbackSubject, to: {
                screen: 'EP_Subject',
                params: { subjectID: fallbackSubject.id },
            } })) : (React.createElement(ColumnCard, { spacing: theme.spacing.standard.sm, ...columnCardProps },
            React.createElement(Label, null, translate('Subjects')),
            isEditMode && onRearrangeSubjects ? (React.createElement(DndContext, { sensors: sensors, collisionDetection: closestCenter, onDragEnd: handleDragEnd },
                React.createElement(SortableContext, { items: subjectIDs, strategy: verticalListSortingStrategy }, renderSubjectList()))) : (renderSubjectList()))) }));
};
const stylesGenerator = createThemedStyle(({}) => ({}));
export default SubjectListAPIHandler;
